import React from "react";

interface IInitialAvatarProps {
  title: string;
  className?: string;
  fontSize?: string; // Tailwind font size class (default: text-xl)
  width?: string; // Tailwind width class (default: w-10)
  height?: string; // Tailwind height class (default: h-10)
}

const getFirstLetter = (title: string) => {
  return title?.charAt(0)?.toUpperCase() || "N";
};
const InitialAvatar: React.FC<IInitialAvatarProps> = ({
  title,
  width = "w-10",
  height = "h-10",
  className,
  fontSize = "text-xl",
}) => {
  return (
    <div
      className={`${width} ${height} ${className} rounded-full bg-gradient-to-br from-coral-pink-300 to-coral-pink-500 flex items-center justify-center`}
    >
      <span className={`text-white font-bold ${fontSize}`}>
        {getFirstLetter(title)}
      </span>
    </div>
  );
};

export default InitialAvatar;
